import { IAnimationStateData, IBoneData, IEvent, ISkeletonData, ITrackEntry, Spine } from "pixi-spine";
import { IReadOnlyResourceManager, IWriteOnlyResourceManager, ResourceManager } from "../../ResourceManager/ResourceManager";
import { IGenericFamilySpine, ISpineTrackAnimation } from "./IGenericFamilySpine";
import { FillingPotParams } from "./FillinPotParams";
import { LogGroup, Point, Scale, Size, randomInclusive, shuffle } from "../../MyHelpers";
import { AudioManager, ITrack, Track } from "../../AudioManager";
import { IInterval } from "../../Context/Interval";
import { IRandomTimeout } from "../../Context/RandomTimeout";
import { ITimeout } from "../../Context/Timeout";
import { ResourceIdentifier } from "../../ResourceManager/ResourceIdentifier";
import { Settings } from "../../Settings";
import { BetConfig, SlotGameBet } from "../../api";
import { IFillinPotFamilyFactory, FillingPotFamilyFeatureFactory } from "./FamilyFactory";
import { FillingPotPhysical } from "./FillingPotPhysical";
import { BonusWillUpdateFillingPotFeature, IFillingPotIncrements } from "./IFillingPotIncrement";
import * as PIXI from 'pixi.js'
import { EventData } from '@pixi-spine/runtime-4.1';
import { IIncrementSavePerBet, ILevelsPerBetsSaved } from "./ILevelsPerBetSaved";
import { TweenMax, Power0 } from "gsap";
import { ILevelAnimation } from "./ILevelAnimationInterface";
import { service } from "../../services";
import { PotCollectPosition } from "./CollectSRAPathFillingPot";

// interface ILevelAnimation {
//     level: number;
//     levelStartAnims: string[];
//     levelLoopAnims: string[];
// }

export class FamilyConstructiveFeature extends IGenericFamilySpine {
    public override ViewPixiAPP(): PIXI.Container {
        throw new Error("Method not implemented.");
    }
    public SetDataPostionPotGlobal(potCollectPosition: PotCollectPosition[]) {
        //throw new Error("Method not implemented.");
    }
    public GetDataPositionPot(): PotCollectPosition[] {
        //throw new Error("Method not implemented.");
        return null
    }
    public override RamclearFillingPot(selecteBet: SlotGameBet) {
        this.availableLevelPerBet.forEach((b) => {
            //await service.api.storageDeleteOne(`${this.gameName}_${this.potName}_${b.Bet.TotalBetCents.InCents}`);
            //console.log("LevelBackend:", apiResult);
            let betFind = this.availableLevelPerBet.find(lbet => lbet.TotalBet == b.TotalBet);
            if (betFind == null) return
            betFind.currentLevel = 0;
            betFind.currentSpin = 0;
        });

        //console.log("Ramclear:",this.availableLevelPerBet)
        console.log(`Ramclear-ConstructiveFillingPotComplete-${this.gameName}`,this.spineHit);
        this.ClearLevels(); 
        if(this.spineHit == null) return
       
        //await this.ResetPoseSpine();
        void this.SetBet(selecteBet);
    }

    public override ReelStops(winSymbolsReelStop : string[]): void {
        //throw new Error("Method not implemented.");
    }
    public override ParticlesDebugger() {
        //throw new Error("Method not implemented.");
    }    
    protected logGroup: LogGroup = null;
    protected resid: ResourceIdentifier = null;
    protected app: PIXI.Application<HTMLCanvasElement> = null;
    protected availableLevelPerBet: ILevelsPerBetsSaved[] = [];
    protected gameResourcesBasePath: string = null;
    //protected changeRandomAnimationSpineInterval: IRandomTimeout = null;
    protected audio: AudioManager = null;
    //protected intervalLevelRAAnimation: IInterval = null;
    protected intervalSRAPathDebugger: IInterval = null;
    protected restartStartIncrementLevelsOneTime: ITimeout = null;
    protected startRALevelLoopTimeout: ITimeout = null;
    protected startIntervalCheckNextLevelAnimation: ITimeout = null;
    protected currentLevelSaved = 0;
    protected spineHit: Spine = null;

    protected startBonusWinFillingTimeOut: ITimeout = null;
    protected controlScalePoint: Point = null;
    protected animationBreathTrackAlphaMixFadeIn = { alphaMix: 0.4 };
    protected animationBreathTrackAlphaMixFadeOut = { alphaMix: 1 };
    protected enabledBets : BetConfig[]
    constructor(familyName: string, params: FillingPotParams, controlScalePoint: Point ) {
        super(params);
        //this.enabledBets = params.initData.EnabledBets;
        //console.log(`${params.gameName}-FamilyType:`, familyName);
        //console.log(`${params.gameName}-Params:`, params);
        this.gameName = params.gameName;
        this.familyType = familyName;
        this.audio = params.audio;
        this.logGroup = params.logGroup.Add("FamilyConstructive");
        this.resid = params.resid.Add("FamilyConstructive");
        this.controlScalePoint = controlScalePoint;

        this.enabledBets = params.initData.EnabledBets;
        params.initData.EnabledBets.forEach((b) => {
            this.availableLevelPerBet.push({
                currentLevel: 0,
                TotalBet: b.Bet.TotalBetCents.InCents,
                currentSpin: 0,
            });

            //let apiResult = await service.api.storageGetOne(`${gameName}_${potElement}_${b.Bet.TotalBetCents.InCents}`);
            //console.log("LevelBackend:",apiResult);
        });

        // //init bet levels and particles 
        // params.initData.EnabledBets.forEach((b) => {

        //     this.availableLevelPerBet.push({
        //         currentLevel: 0,
        //         TotalBet: b.Bet.TotalBetCents.InCents,
        //         currentSpin: 0,
        //     })
        // });

        this.gameResourcesBasePath = params.gameResourcesBasePath;

        let indexAnimationColletpath: number = 0;
        this.intervalSRAPathDebugger = params.systemContext.TimingContext().CreateInterval("pathSRA-Debugger", 1500, () => {
            if (indexAnimationColletpath < this.animationArrayCollect.length) {
                let animationTrack = this.allAnimationMap.get(this.animationArrayCollect[indexAnimationColletpath]);
                this.PlayAnimationSpine(animationTrack.animationName, animationTrack.trackAnimationIndex, animationTrack.soundTrack);
                indexAnimationColletpath++;
            } else {
                indexAnimationColletpath = 0;
                this.intervalSRAPathDebugger.Stop();
            }
        });

        this.restartStartIncrementLevelsOneTime = params.systemContext.TimingContext().CreateTimeout("RestartStartIncrementLevelsOneTime", 1500, () => {
            this.startIncrementLevelsOneTime = false;
        })

        this.startRALevelLoopTimeout = params.systemContext.TimingContext().CreateTimeout("StartAnimLoopCurrentLevel", 500, () => {
            if (this.spineHit == null) {
                return
            }
            if (this.someLevelAnimISPlaying == true) return;

            this.ClearLastLevel();
            //play anim next loop level
            let newLevelAnimationArray = this.allLevelAnimationGrouped.filter(animsLevel => animsLevel.level == this.currentLevelPlaying);
            if (newLevelAnimationArray.length > 0) {
                //console.log(`CurrentLevelAnimLoop-${this.currentLevel}:`, newLevelAnimationArray[0]?.levelLoopAnims);
                for (let animationIndex = 0; animationIndex < newLevelAnimationArray[0]?.levelLoopAnims.length; animationIndex++) {
                    let trackAniamtion = this.allAnimationMap.get(newLevelAnimationArray[0]?.levelLoopAnims[animationIndex]);
                    this.allAnimationMap.get(newLevelAnimationArray[0]?.levelLoopAnims[animationIndex]).isActive = true;
                    this.allAnimationMap.get(newLevelAnimationArray[0]?.levelLoopAnims[animationIndex]).loopAnimation = true;
                    this.PlayAnimationSpine(trackAniamtion.animationName, trackAniamtion.trackAnimationIndex, trackAniamtion.soundTrack);
                }
            }
            this.animationLevelTiming = 0;
            //lastindex = null;
            newLevelAnimationArray = null;
        });

        this.startBonusWinFillingTimeOut = params.systemContext.TimingContext().CreateTimeout("StartBonusWinFillingTimeOut", 600, () => {
            this.ClearLevels();
            //this.spineHit?.state?.clearTrack(this.trackIndexAnimSpecialGameConnected);
            this.spineHit?.state?.clearTrack(0);

            //this.spineTrackMap.get("collectHitBonus")?.PlayLoop(Track.LoopForEver);
            if (this.allAnimationMap.has("BN_BONUS") && this.spineHit?.state) {
                let animationTrack = this.allAnimationMap.get("BN_BONUS");
                this.allAnimationMap.get("BN_BONUS").isActive = true;
                this.PlayAnimationSpine(animationTrack.animationName, animationTrack.trackAnimationIndex, animationTrack.soundTrack);
                if (this.allAnimationMap.has(this.animatioBreathName) == true) {
                    this.AddQueueAnimation(this.animatioBreathName, 1, false, animationTrack.duration , this.spineHit);
                    //this.PlayAnimationSpine(this.animatioBreathName, 1, null);
                };
            }           

            

            this.currentLevelSaved = 0;
            this.currentSpin = 0;
        });

        this.backgroundLiveSpineTimeout = params.systemContext.TimingContext().CreateTimeout("backgroundLiveSpineTimeout", 100, () => {
            for (let animIndexBG = 0; animIndexBG < this.animationArrayBackground.length; animIndexBG++) {
                let animationTrack = this.allAnimationMap.get(this.animationArrayBackground[animIndexBG]);
                this.allAnimationMap.get(this.animationArrayBackground[animIndexBG]).isActive = true;
                this.PlayAnimationSpine(this.animationArrayBackground[animIndexBG], animationTrack.trackAnimationIndex, animationTrack.soundTrack);
            }
        });

        // this.changeRandomAnimationSpineInterval = params.systemContext.TimingContext().CreateRandomTimeout("changeAnimationInterval", 60000, 300000, () => {
        //     if (this.animationArrayRASuffle.length > 0) {

        //         this.lastindexAnimInterval = this.currentRandomAnimationIndex;
        //         if (this.currentRandomAnimationIndex == this.animationArrayRASuffle.length - 1) {
        //             this.animationArrayRASuffle = shuffle(this.animationArrayRASuffle);
        //             //console.log("DoAnotherShuffledAnimation:", this.animationArrayRASuffle);
        //         }
        //         this.currentRandomAnimationIndex = (this.currentRandomAnimationIndex + 1) % this.animationArrayRASuffle.length;
        //         let animationTrack = this.allAnimationMap.get(this.animationArrayRASuffle[this.currentRandomAnimationIndex]);
        //         this.PlayAnimationSpine(animationTrack.animationName, animationTrack.trackAnimationIndex, animationTrack.soundTrack);
        //         let audio = this.spineTrackMap.get(this.animationArrayRASuffle[this.currentRandomAnimationIndex])
        //         audio?.Play(false);
        //         this.changeRandomAnimationSpineInterval.ChangeTimeoutFromTo((animationTrack.duration * 1000) + 60000, (animationTrack.duration * 1000) + 300000);
        //         this.lastindexAnimInterval = this.currentRandomAnimationIndex;
        //         this.changeRandomAnimationSpineInterval.Start();
        //         audio = null;
        //     }
        // });



        this.startIntervalCheckNextLevelAnimation = params.systemContext.TimingContext().CreateTimeout("startIntervalCheckNextLevelAnimation", 1000, () => {
            this.someLevelAnimISPlaying = false;
            this.PlayCurrentLevelAnimation();
        });
    }
    
    public override async PrepareResources(resourceManager: IWriteOnlyResourceManager): Promise<void> {

        for (let b of this.enabledBets) {
            let apiResult = await service.api.storageGetOne(`${this.gameName}_${b.Bet.TotalBetCents.InCents}`);
            //console.log("LevelBackend:", apiResult);
            let betFind = this.availableLevelPerBet.find(lbet => lbet.TotalBet == b.Bet.TotalBetCents.InCents);
            if (apiResult == null) return
            betFind.currentLevel = parseInt(apiResult);
        };

        console.log(`Level-SavedDB-Constructive-${this.gameName}:`,this.availableLevelPerBet)

    }
    public override async ResourcesLoaded(resourceManager: IReadOnlyResourceManager): Promise<void> {
    }
    //protected currentRandomAnimationIndex: number = -1;
    protected allAnimationMap: Map<string, ISpineTrackAnimation> = new Map<string, ISpineTrackAnimation>();

    protected startIndexRandomAnimation: number = null;
    protected animationArrayCollect: string[] = [];
    //protected animationArrayRASuffle: string[] = [];
    protected animationArrayBackground: string[] = [];
    //protected animationArrayRA: string[] = [];
    //protected lastindexAnimInterval: number = -1;
    protected animationRanbomTrack: ITrackEntry = null;
    protected countLevelAnimation: number = 0;



    //create for the Family-Constructive
    protected trackIndexAnimSpecialGameConnected = 0;
    protected trackIndexIDLE = 0;
    protected levelIndexAnim = 100;
    protected levelLoopIndexAnim = 100;
    //protected levelRAIndexAnim = 400;    
    protected backgroundIndexAnim = 80;
    protected collectStartTrackIndex = 5;
    protected backgroundLiveSpineTimeout: ITimeout = null;
    
    protected allLevelAnimationGrouped: ILevelAnimation[] = [];
    //protected randomAnimationIndex : number = 2;

    //create event for spine
    protected eventSpine = (trackIndex: ITrackEntry, event: IEvent) => {
        // Check if the event name matches your desired trigger                   
        let eventdata = event as unknown as EventData;
        //console.log(`Track EventData : ${{trackIndex}} `, trackIndex,eventdata);
        //console.log(`Track Event : ${{trackIndex}} `, trackIndex,event);

        //stops animation when pathAnim its finished
        if (eventdata.stringValue == "pathStart") {
            //this.audio.Play(this.resid.ScopedResourceName("collectHitStartSound"));
            this.spineTrackMap.get("collectHitStartSound").Play();
        }
        else if (eventdata.stringValue == "pathFinished") {
            //play sound for finish path collect anim                                                                                                  
            void this.IncrementLevels();
        }

        eventdata = null;
        trackIndex = null;
    };

    protected countBonusAnim = 0;
    protected AnimComplete = (trackComplete: ITrackEntry) => {
        
        if (this.allAnimationMap.get(trackComplete.animation.name)?.loopAnimation == true) {
            let trackAnimation = this.allAnimationMap.get(trackComplete.animation.name);
            this.PlayAnimationSpine(trackAnimation.animationName, trackComplete.trackIndex, trackAnimation.soundTrack, null, true, trackComplete);
        }
        else {
            if(trackComplete.trackIndex == 0 ) return 
            else this.spineHit?.state?.clearTrack(trackComplete.trackIndex);
        }
    }



    protected StartAnim = (trackComplete: ITrackEntry) => {
    }

    //create anim for spine 
    //same for all family    
    // protected animationBreathTrack: ITrackEntry = null;
    protected animatioBreathName: string = null;
    protected startBonusWin: boolean = false;
    protected elementTextPIXIAPP: PIXI.Text = null;
    //protected elementTextPIXIAPP : PIXI.Text = null;
    public override CreateAnimFamilyFeature(spineHit: Spine) {
        // //Check if spine hit was create ok 
        this.spineHit = spineHit;
        this.startBonusWin = false;
        // Add an event listener to the Spine animation           
        this.spineHit?.state?.addListener({
            event: this.eventSpine,
            complete: this.AnimComplete,
            //start: this.StartAnim
        });

        this.SetAnimationIndex();
        this.CheckAnimationCollectPath();
        this.SetLevelAnimation();
        this.CreateDebuggerView();
        this.SetMixAnimation();
        this.InitAnimation();
    }

    protected SetAnimationIndex(){
        this.spineHit.state.data.skeletonData.animations.forEach((anim, index) => {

            let spineTrackAnimation: ISpineTrackAnimation = {
                trackAnimationIndex: 0,
                loopAnimation: false,
                soundTrack: null,
                duration: 0,
                animationName: "",
                isActive: false
            }


            //this.allAnimationArray.push(anim);
            if (anim.name.includes("animationCollectPath_")) {
                this.animationArrayCollect.push(anim.name);
                spineTrackAnimation.loopAnimation = false;
                spineTrackAnimation.trackAnimationIndex = index ;
            }

            else if (anim.name.includes("RA_")) {
             return
            }
            else if (anim.name.includes("BG_")) {
                this.animationArrayBackground.push(anim.name);
                spineTrackAnimation.loopAnimation = true;
                spineTrackAnimation.trackAnimationIndex = index;
            }
            else if (anim.name.includes("IDLE_")) {
                this.animatioBreathName = anim.name;
                spineTrackAnimation.trackAnimationIndex = this.trackIndexIDLE;
                spineTrackAnimation.loopAnimation = true;
                spineTrackAnimation.animationName = anim.name;
                spineTrackAnimation.isActive = true;
            }

            else if (anim.name.includes("Level_Full_Idle")) {
                //this.animatioBreathName = anim.name;
                spineTrackAnimation.trackAnimationIndex = this.trackIndexAnimSpecialGameConnected;
                spineTrackAnimation.loopAnimation = true;
                spineTrackAnimation.animationName = anim.name;
                spineTrackAnimation.isActive = true;
            }

            else if (anim.name.includes("LevelStartHit")) {
                spineTrackAnimation.trackAnimationIndex = this.trackIndexAnimSpecialGameConnected;
                spineTrackAnimation.loopAnimation = false;
                spineTrackAnimation.soundTrack = this.spineTrackMap.get("collectHitSound");
            }

            else if (anim.name.includes("LevelAnimation_Full_LevelStart")) {
                spineTrackAnimation.trackAnimationIndex = this.levelIndexAnim + index;
                spineTrackAnimation.loopAnimation = false;
                spineTrackAnimation.soundTrack = this.spineTrackMap.get("collectHitSound");
            }

            else if (anim.name.includes("LevelAnimation_Default")) {
                spineTrackAnimation.trackAnimationIndex = this.levelIndexAnim;
                spineTrackAnimation.loopAnimation = true;
            }

            else if (anim.name.includes("EXPECTATION")) {
                spineTrackAnimation.trackAnimationIndex = this.trackIndexAnimSpecialGameConnected;
                spineTrackAnimation.loopAnimation = false;
                spineTrackAnimation.soundTrack = this.spineTrackMap.get("spineAnticipation");
            }

            else if (anim.name.includes("BN_BONUS")) {
                spineTrackAnimation.trackAnimationIndex = this.trackIndexAnimSpecialGameConnected;
                spineTrackAnimation.loopAnimation = false;
                spineTrackAnimation.soundTrack = this.spineTrackMap.get("collectHitBonus");
            }

            else if (anim.name.includes("BN_START")) {
                spineTrackAnimation.trackAnimationIndex = this.trackIndexAnimSpecialGameConnected;
                spineTrackAnimation.loopAnimation = false;
                spineTrackAnimation.soundTrack = this.spineTrackMap.get("BN_START");
            }

            else if (anim.name.includes("_Loop")) {
                spineTrackAnimation.trackAnimationIndex = this.levelLoopIndexAnim + index ;
                spineTrackAnimation.loopAnimation = true;
            }

            else if (anim.name.includes("_LevelStar")) {
                spineTrackAnimation.trackAnimationIndex = this.levelIndexAnim + index ;
                spineTrackAnimation.loopAnimation = false;
                if (this.spineTrackMap.has(anim.name)) spineTrackAnimation.soundTrack = this.spineTrackMap.get(anim.name);
            }



            spineTrackAnimation.duration = anim.duration;
            spineTrackAnimation.animationName = anim.name;
            this.allAnimationMap.set(anim.name, spineTrackAnimation);
        });

    }

    protected CheckAnimationCollectPath(){
        let hasAll = true;

        for (let reel = 0; hasAll && reel < this.params.initData.PlayWindow.Width; reel++) {
            for (let row = 0; hasAll && row < this.params.initData.PlayWindow.Height; row++) {
                if (!this.allAnimationMap.has(`animationCollectPath_${reel}_${row}`)) {
                    hasAll = false;
                }
            }
        }

        // if we don't have all animations for animationCollectPath, lets delete all and not use it
        if (!hasAll) {
            //this.animationArrayCollect = [];
            for (let reel = 0; hasAll && reel < this.params.initData.PlayWindow.Width; reel++) {
                for (let row = 0; hasAll && row < this.params.initData.PlayWindow.Height; row++) {
                    this.allAnimationMap.delete(`animationCollectPath_${reel}_${row}`);
                }
            }
        }
    }


    protected InitAnimation(){

        //start anim idle 
        if (this.allAnimationMap.has(this.animatioBreathName) == true) {
            this.allAnimationMap.get(this.animatioBreathName).isActive = true;
            this.PlayAnimationSpine(this.animatioBreathName, this.trackIndexIDLE, null);

        };
        //default Levels
        if (this.allAnimationMap.has("LevelAnimation_Default") == true) {
            let trackAnimation = this.allAnimationMap.get("LevelAnimation_Default");
            this.allAnimationMap.get(trackAnimation.animationName).isActive = true;
            this.allAnimationMap.get(trackAnimation.animationName).loopAnimation = true;
            this.PlayAnimationSpine(trackAnimation.animationName, trackAnimation.trackAnimationIndex, trackAnimation.soundTrack);
        }

        if (this.animationArrayBackground.length > 0) {
            this.backgroundLiveSpineTimeout.Start();
        }

        this.startIndexRandomAnimation = this.spineHit?.state?.data?.skeletonData?.animations?.findIndex(animation => animation.name.includes("RA_"))


        // this.animationArrayRASuffle = shuffle(this.animationArrayRA);

        // //Create interval for RA animation 
        // if (this.animationArrayRASuffle.length > 0) {
        //     this.changeRandomAnimationSpineInterval.Start();
        // }

    }

    protected SetLevelAnimation() {
        //find Animation LevelStart 
        let animations = this.spineHit?.spineData?.animations.map(s => s.name);
        let levels = animations
            .map(a => a.match(/LevelAnimation_([0-9]+)_/))
            .filter(l => l != null)
            .map(l => l[0]);
        let uniqueLevels = levels.filter((item, index, array) => array.indexOf(item) == index);
        this.allLevelAnimationGrouped = uniqueLevels.map(l => ({
            level: parseInt(l.match(/LevelAnimation_([0-9]+)_/)[1]),
            levelStartAnims: animations.filter(a => a.startsWith(l + "LevelStar")),
            levelLoopAnims: animations.filter(a => a.startsWith(l + "Loop"))
        }))
            .sort((a, b) => a.level - b.level);


        this.countLevelAnimation = this.allLevelAnimationGrouped.length;
        animations = null;
        levels = null;
        uniqueLevels = null;
    }

    protected CreateDebuggerView() {
        //CreateContainerForShoNameAnimation
        this.elementTextPIXIAPP = new PIXI.Text(
            this.resid.ScopedResourceName("elementTextPIXIAPP"),
            {
                fontFamily: 'NotoSansDisplay-Bold',
                fontSize: Scale.fh(40),
                fontWeight: 'bold',
                fill: ["white"], // gradient
                stroke: 'black',
                strokeThickness: Scale.fh(8),
                //wordWrap: true,			
                lineJoin: 'round',
                //textBaseline : "middle",			
            }
        );

        this.elementTextPIXIAPP.visible = false;
        this.elementTextPIXIAPP.name = "AnimationLevel-LayoutText";
        this.elementTextPIXIAPP.x = Scale.X(19);
        this.elementTextPIXIAPP.y = Settings.Enable2plus1 == true ? Scale.Y(2003.5) : Scale.Y(448.5)
        this.spineHit.parent.addChild(this.elementTextPIXIAPP);


        //add container to particlesHit
        let containerchildrensSpine = this.spineHit.children as PIXI.Container[];
        containerchildrensSpine.find((container) => {
            if (container.name == "root") {
                container.addChild(this.elementTextPIXIAPP);
            }
        });
    }

    protected SetMixAnimation( mixAnimationDuration : number = 0.1 ) {
        if (this.allAnimationMap.has("LevelStartHit") && this.allAnimationMap.has(this.animatioBreathName)) this.spineHit?.state.data.setMix(this.animatioBreathName, "LevelStartHit",mixAnimationDuration);
        if (this.allAnimationMap.has("EXPECTATION") && this.allAnimationMap.has(this.animatioBreathName)) this.spineHit?.state.data.setMix(this.animatioBreathName, "EXPECTATION",mixAnimationDuration);
        if (this.allAnimationMap.has("LevelStartHit") && this.allAnimationMap.has(this.animatioBreathName)) this.spineHit?.state.data.setMix("LevelStartHit", this.animatioBreathName,mixAnimationDuration);
        if (this.allAnimationMap.has("EXPECTATION") && this.allAnimationMap.has(this.animatioBreathName)) this.spineHit?.state.data.setMix("EXPECTATION", this.animatioBreathName,mixAnimationDuration);
        if (this.allAnimationMap.has("BN_START") && this.allAnimationMap.has(this.animatioBreathName)) this.spineHit?.state.data.setMix(this.animatioBreathName, "BN_START",mixAnimationDuration);
        if (this.allAnimationMap.has("BN_BONUS") && this.allAnimationMap.has(this.animatioBreathName)) this.spineHit?.state.data.setMix(this.animatioBreathName, "BN_BONUS",mixAnimationDuration);
        if (this.allAnimationMap.has("BN_START") && this.allAnimationMap.has("BN_BONUS")) this.spineHit?.state.data.setMix("BN_START", "BN_BONUS",mixAnimationDuration);
    }


    //only collect for constructive 1 time 
    protected startIncrementLevelsOneTime: boolean = false;
    protected animationLevelTiming: number = 0;
    protected currentLevelPlaying = 0;
    protected async IncrementLevels() {
        if (this.spineHit == null) return
        if (this.startIncrementLevelsOneTime == false && this.bonusWinHasHitted == false) {
            this.startIncrementLevelsOneTime = true;

            //play animation LevelStartHit  
            let newLevel = this.currentLevelSaved + 1;
            if (newLevel <= this.countLevelAnimation && newLevel <= Math.trunc(this.percetageIncrementLevels)) {
                this.currentLevelSaved++;
                if (this.allAnimationMap.has("LevelAnimation_Default") == true && this.allAnimationMap.get("LevelAnimation_Default").loopAnimation == true) {
                    let trackAnimation = this.allAnimationMap.get("LevelAnimation_Default");
                    this.allAnimationMap.get(trackAnimation.animationName).isActive = false;
                    this.allAnimationMap.get(trackAnimation.animationName).loopAnimation = false;
                    //this.spineHit?.state?.clearTrack(trackAnimation.trackAnimationIndex);
                }
                //console.log("CurrentLevelSaved", this.currentLevelSaved);
                this.PlayCurrentLevelAnimation();
            }
            else if (this.currentLevelSaved >= this.countLevelAnimation) {

                if (this.someLevelAnimISPlaying == false) {
                    this.someLevelAnimISPlaying = true;

                    if (this.allAnimationMap.has("LevelAnimation_Full_LevelStart") && this.spineHit?.state) {
                        let trackAniamtion = this.allAnimationMap.get("LevelAnimation_Full_LevelStart");
                        this.PlayAnimationSpine(trackAniamtion.animationName, trackAniamtion.trackAnimationIndex, trackAniamtion.soundTrack);

                        if (this.allAnimationMap.has(this.animatioBreathName) == true) {
                            this.AddQueueAnimation(this.animatioBreathName, this.trackIndexIDLE, false, 0, this.spineHit);
                        };

                        if (this.allAnimationMap.has("Level_Full_Idle") == true) {
                            let trackAniamtionLevelFull = this.allAnimationMap.get("Level_Full_Idle");
                            this.AddQueueAnimation("Level_Full_Idle", trackAniamtionLevelFull.trackAnimationIndex, false, 0, this.spineHit);
                        };

                        setTimeout(() => {
                            this.someLevelAnimISPlaying = false;
                        }, (trackAniamtion.duration * 1000) + 3500);
                    }
                }

            }
            newLevel = null;

        }

        this.restartStartIncrementLevelsOneTime.Start();

        //Save currentLevel by percentaje
        await this.SaveCurrentIncrement();
    }

    protected CheckNextLevelAnim() {
        if ((this.currentLevelPlaying + 1) <= this.currentLevelSaved) {

            this.startIntervalCheckNextLevelAnimation.ChangeTimeout((this.animationLevelTiming + 2.2) * 1000);
            this.startIntervalCheckNextLevelAnimation.Start();
        } else {
            //setTimeout(() => {                
            this.someLevelAnimISPlaying = false;
            this.startRALevelLoopTimeout.Start();
        }
    }

    protected someLevelAnimISPlaying: boolean = false;
    protected PlayCurrentLevelAnimation() {

        this.startRALevelLoopTimeout.Stop();
        if (this.currentLevelPlaying == this.currentLevelSaved) {
            // if(this.currentLevelPlaying == this.countLevelAnimation) {            
            return
        };

        if (this.someLevelAnimISPlaying == false) {
            this.startIncrementLevelsOneTime = true;

            this.animationLevelTiming = 0;
            this.someLevelAnimISPlaying = true;
            this.currentLevelPlaying++;
            this.ClearLastLevel();
            let animationLevelHitStart: ITrackEntry = null;
            let LevelAnimationArray = this.allLevelAnimationGrouped.filter(animsLevel => animsLevel.level == this.currentLevelPlaying);
            for (let animationIndex = 0; animationIndex < LevelAnimationArray[0]?.levelStartAnims.length; animationIndex++) {
                let trackAnimation = this.allAnimationMap.get(LevelAnimationArray[0]?.levelStartAnims[animationIndex]);
                this.allAnimationMap.get(LevelAnimationArray[0]?.levelStartAnims[animationIndex]).isActive = false;
                this.allAnimationMap.get(LevelAnimationArray[0]?.levelStartAnims[animationIndex]).loopAnimation = false;
                if (this.animationLevelTiming < trackAnimation.duration) {
                    this.animationLevelTiming = trackAnimation.duration;
                }

                this.ShowDebuggerAnim(trackAnimation)
                this.PlayAnimationSpine(trackAnimation.animationName, trackAnimation.trackAnimationIndex, trackAnimation.soundTrack);
            }
            //------------------------------------------------- debugger

            this.startRALevelLoopTimeout.ChangeTimeout((this.animationLevelTiming * 1000));
            //this.startRALevelLoopTimeout.Start();
            LevelAnimationArray = null;
            let animationDurationTrack: number = 1;
            if (this.allAnimationMap.has("LevelStartHit") == true && this.spineHit != null) {
                let animationTrack = this.allAnimationMap.get("LevelStartHit");
                animationDurationTrack = animationTrack.duration;
                this.PlayAnimationSpine(animationTrack.animationName, animationTrack.trackAnimationIndex, animationTrack.soundTrack)
            }
            if (this.allAnimationMap.has(this.animatioBreathName) == true) {
                this.AddQueueAnimation(this.animatioBreathName, this.trackIndexIDLE, false, animationDurationTrack, this.spineHit);
                this.restartStartIncrementLevelsOneTime.Start()
            };
        };

        this.CheckNextLevelAnim();
    }


    protected ShowDebuggerAnim(trackAnimation: ISpineTrackAnimation) {
        if (this.elementTextPIXIAPP.visible == true) {
            this.elementTextPIXIAPP.text = trackAnimation.animationName;
            setTimeout(() => {
                this.elementTextPIXIAPP.visible = false;
                this.elementTextPIXIAPP.text = "";
            }, this.animationLevelTiming * 1000)
        }
        console.log("LevelAnimation-Name : " , trackAnimation.animationName);
    }



    /** use for SetBet and change timeTrack per bet for Spine if you was played and hit some SRA */
    protected selectedBet: SlotGameBet = null;
    protected currentLevelPerBet: ILevelsPerBetsSaved = null;
    public async SetBet(selectedBet: SlotGameBet) {
        this.selectedBet = selectedBet;
        this.currentLevelPerBet = this.availableLevelPerBet.find(levelPerBet => levelPerBet.TotalBet == this.selectedBet.TotalBetCents.InCents);
        this.currentSpin = this.currentLevelPerBet.currentSpin;
        this.percetageIncrementLevels = this.currentSpin * (this.countLevelAnimation / this.spinsForHitBonus);
        this.currentLevelSaved = this.currentLevelPerBet.currentLevel;
        this.currentLevelPlaying = this.currentLevelPerBet.currentLevel;
        this.BetLevel();
        await this.SaveCurrentIncrement();
    }

    //protected LevelAnimationArray :  ILevelAnimation[] = [];
    protected BetLevel() {
        this.ClearLevels();
        this.ResetPoseSpine();
        if (this.spineHit == null) return
        let anim: ITrackEntry = null;
        //console.log("BETLEVEL:", this.currentLevelSaved)
        if (this.currentLevelSaved == 0) {
            if (this.allAnimationMap.has("LevelAnimation_Default") == true && this.spineHit != null) {
                let trackAnimation = this.allAnimationMap.get("LevelAnimation_Default");
                this.allAnimationMap.get(trackAnimation.animationName).isActive = true;
                this.allAnimationMap.get(trackAnimation.animationName).loopAnimation = true;
                this.PlayAnimationSpine(trackAnimation.animationName, trackAnimation.trackAnimationIndex, trackAnimation.soundTrack);
            }
        } else if (this.allAnimationMap.has("LevelAnimation_Default") == true) {
            let trackAnimation = this.allAnimationMap.get("LevelAnimation_Default");
            this.allAnimationMap.get(trackAnimation.animationName).isActive = false;
            this.allAnimationMap.get(trackAnimation.animationName).loopAnimation = false;
            //this.spineHit?.state?.clearTrack(trackAnimation.trackAnimationIndex);
        }
        for (let restartcurrentLevel = this.currentLevelSaved; restartcurrentLevel <= this.currentLevelSaved; restartcurrentLevel++) {
            let LevelAnimationArray = this.allLevelAnimationGrouped.filter(animsLevel => animsLevel.level == restartcurrentLevel);
            //console.log(`ResctartLevelAnim-${restartcurrentLevel}:`, LevelAnimationArray[0]?.levelStartAnims);
            if (LevelAnimationArray.length == 0) break
            for (let animationIndex = 0; animationIndex < LevelAnimationArray[0]?.levelStartAnims.length; animationIndex++) {

                let trackAnimation = this.allAnimationMap.get(LevelAnimationArray[0]?.levelStartAnims[animationIndex]);
                if (this.animationLevelTiming < trackAnimation.duration) {
                    this.animationLevelTiming = trackAnimation.duration;                    
                }

                this.startRALevelLoopTimeout.ChangeTimeout((this.animationLevelTiming * 1000));                

                this.PlayAnimationSpine(trackAnimation.animationName, trackAnimation.trackAnimationIndex, trackAnimation.soundTrack, 1);
            }
            LevelAnimationArray = null;
        };
        this.startRALevelLoopTimeout.Start();        
        anim = null;
    }

    protected ClearLevels() {

        for (let restartcurrentLevel = 1; restartcurrentLevel <= this.countLevelAnimation; restartcurrentLevel++) {
            let LevelAnimationArray = this.allLevelAnimationGrouped.filter(animsLevel => animsLevel.level == restartcurrentLevel);

            for (let animationIndex = 0; animationIndex < LevelAnimationArray?.[0]?.levelStartAnims?.length; animationIndex++) {
                this.allAnimationMap.get(LevelAnimationArray?.[0]?.levelStartAnims[animationIndex]).isActive = false;
                this.allAnimationMap.get(LevelAnimationArray?.[0]?.levelStartAnims[animationIndex]).loopAnimation = false;
                this.spineHit?.state?.addEmptyAnimation(this.allAnimationMap.get(LevelAnimationArray?.[0]?.levelStartAnims[animationIndex]).trackAnimationIndex, 0, 0);
                this.spineHit?.state?.setEmptyAnimation(this.allAnimationMap.get(LevelAnimationArray?.[0]?.levelStartAnims[animationIndex]).trackAnimationIndex, 0);
            }
            for (let animationIndex = 0; animationIndex < LevelAnimationArray?.[0]?.levelLoopAnims?.length; animationIndex++) {
                this.allAnimationMap.get(LevelAnimationArray?.[0]?.levelLoopAnims[animationIndex]).isActive = false;
                this.allAnimationMap.get(LevelAnimationArray?.[0]?.levelLoopAnims[animationIndex]).loopAnimation = false;
                this.spineHit?.state?.addEmptyAnimation(this.allAnimationMap.get(LevelAnimationArray?.[0]?.levelLoopAnims[animationIndex]).trackAnimationIndex, 0, 0);
                this.spineHit?.state?.setEmptyAnimation(this.allAnimationMap.get(LevelAnimationArray?.[0]?.levelLoopAnims[animationIndex]).trackAnimationIndex, 0);
            }
            LevelAnimationArray = null;
        }
    }

    protected ResetPoseSpine() {
        this.spineHit?.skeleton?.setBonesToSetupPose();
        this.spineHit?.skeleton?.setToSetupPose();
        this.spineHit?.skeleton?.setSlotsToSetupPose();
        //this.spineHit?.update(0);
    }

    protected bonusWinHasHitted: boolean = false;

    public async StartBonusWin(bonusName: string) {
      
        if (BonusWillUpdateFillingPotFeature.includes(bonusName)) {
            if (this.allAnimationMap.has("LevelAnimation_Default") == true) {
                let trackAnimation = this.allAnimationMap.get("LevelAnimation_Default");
                this.allAnimationMap.get(trackAnimation.animationName).isActive = false;
                this.allAnimationMap.get(trackAnimation.animationName).loopAnimation = false;
                this.spineHit?.state?.clearTrack(trackAnimation.trackAnimationIndex);                
            }
    
            this.startBonusWin = true;
            //this.changeRandomAnimationSpineInterval?.Stop();
            //this.intervalLevelRAAnimation?.Stop();
            this.startRALevelLoopTimeout?.Stop();
            this.startIntervalCheckNextLevelAnimation.Stop();
            this.bonusWinHasHitted = true;
            //if (this.spineHit != null) {     
            this.ClearLevels();


            if (this.currentLevelPlaying < this.countLevelAnimation && this.spineHit != null) {
                this.currentLevelPlaying = this.currentLevelPlaying == 0 ? 1 : this.currentLevelPlaying;
                for (let currentLevelAnim = this.currentLevelPlaying; currentLevelAnim <= this.countLevelAnimation; currentLevelAnim++) {
                    let LevelAnimationArray = this.allLevelAnimationGrouped.filter(animsLevel => animsLevel.level == currentLevelAnim);
                    for (let animationIndex = 0; animationIndex < LevelAnimationArray[0]?.levelStartAnims.length; animationIndex++) {
                        let trackAnimation = this.allAnimationMap.get(LevelAnimationArray[0]?.levelStartAnims[animationIndex]);
                        this.spineHit?.state?.addEmptyAnimation(trackAnimation.trackAnimationIndex + animationIndex, 0, 0);
                        this.spineHit?.state?.setEmptyAnimation(trackAnimation.trackAnimationIndex + animationIndex, 0);
                        this.PlayAnimationSpine(trackAnimation.animationName, trackAnimation.trackAnimationIndex, null, 20);
                    }
                    LevelAnimationArray = null;
                }
            }
            this.currentLevelSaved = 0;
            this.currentSpin = 0;

            if (this.allAnimationMap.has("BN_START") && this.spineHit?.state) {
                let animationTrack = this.allAnimationMap.get("BN_START");
                this.PlayAnimationSpine(animationTrack.animationName, animationTrack.trackAnimationIndex, animationTrack.soundTrack);
                this.startBonusWinFillingTimeOut.ChangeTimeout((animationTrack.duration * 1000) + 500)
            }
            this.startBonusWinFillingTimeOut?.Start();
        }
        //});

        await this.SaveCurrentIncrement();
    }

    //protected animationExpectation : ITrackEntry = null
    public StartAnticipationBegin() {
        //this.changeRandomAnimationSpineInterval?.Stop()
        if (this.allAnimationMap.has("EXPECTATION") == true && this.spineHit != null) {
            let trackAnimation = this.allAnimationMap.get("EXPECTATION");
            this.allAnimationMap.get("EXPECTATION").isActive = true;
            this.PlayAnimationSpine(trackAnimation.animationName, trackAnimation.trackAnimationIndex, trackAnimation.soundTrack)
            //this.changeRandomAnimationSpineInterval.ChangeTimeoutFromTo((trackAnimation.duration * 1000) + 60000, (trackAnimation.duration * 1000) + 300000)
            if (this.allAnimationMap.has(this.animatioBreathName) == true) {
                this.AddQueueAnimation(this.animatioBreathName, this.trackIndexIDLE, false, 0 , this.spineHit);
            };
        }
        //setTimeout(this.spineHit?.state.clearTrack(0));   

    }

    public EndAnticipationBegin() {
        //this.changeRandomAnimationSpineInterval?.Start();
    }



    protected spinsForHitBonus: number = 60;
    protected currentSpin: number = 0;
    protected percetageIncrementLevels: number = 0;
    protected particlesCount: number = 0;
    /** set new increment for change scale for part in spine */
    public StartIncrement(fillingPotIncrements: IFillingPotIncrements): void {
        //play animation path depends reel and row index 
        if (!this.spineHit) {
            // no spine
            return;
        }
        //let animationCollectPath : ITrackEntry = null;
        fillingPotIncrements.ScatterCordinates?.forEach(s => {
            const animationName = `animationCollectPath_${s.Reel}x${s.Row}`;
            if (!this.allAnimationMap.has(animationName)) {
                // no animation
                return;
            }

            //let trackIndex: number = this.allAnimationMap.get(animationName).trackAnimationIndex + this.collectStartTrackIndex;            
            let trackAnim = this.allAnimationMap.get(animationName);
            this.PlayAnimationSpine(animationName, trackAnim.trackAnimationIndex, trackAnim.soundTrack, 1.7);
        });
    }

    public async UpdateSpin() {
        this.currentSpin++;
        //console.log("Bet-CurrentSpin:", this.currentSpin);
        this.percetageIncrementLevels = this.currentSpin * (this.countLevelAnimation / this.spinsForHitBonus);
        //console.log("Bet-CurrentSpinFillingPot-LevelsToIncrement:", this.percetageIncrementLevels);
        //let countAllLevels = this.allAnimationArray.filter(anim => anim.includes(`LevelAnimation_${this.currentLevel}_LevelStart`)).length
        //save current Spin
        //await this.SaveCurrentIncrement();
    }

    /** save new increment per denom its missing add per pet */
    public async SaveCurrentIncrement() {
        let currentLevelPerBet = this.availableLevelPerBet.find(levelPerBet => levelPerBet.TotalBet == this.selectedBet.TotalBetCents.InCents);
        this.currentLevelPerBet.currentLevel = this.currentLevelSaved;
        this.currentLevelPerBet.currentSpin = this.currentSpin
        //console.log(`${this.gameName}-LevelsSaveBetPerLevel-:`, currentLevelPerBet);

        await service.api.storageSetOne(`${this.gameName}_${this.selectedBet.TotalBetCents.InCents}`,this.currentLevelSaved.toString());
     
    }


    /** pause loop anim*/
    public StopAnim(): void {
        //this.changeRandomAnimationSpineInterval?.Stop();
        //this.audio.Stop(this.resid.ScopedResourceName("collectHitBonus"));
        //this.spineTrackMap.get("collectHitBonus")?.Stop();
        // if (this.allAnimationMap.has("BN_BONUS")) {
        //     this.allAnimationMap.get("BN_BONUS").isActive = false;
        //     this.allAnimationMap.get("BN_BONUS").loopAnimation = false;
        // }
        //this.SaveCurrentIncrement();        
    }

    /** restart loop anim */
    public RestartAnim(): void {
        //this.changeRandomAnimationSpineInterval?.Start();
        //this.intervalLevelRAAnimation?.Start();
    }

    public LevelDebuggerTest(levelTestit: number) {
        if (levelTestit != null) {
            this.percetageIncrementLevels = levelTestit;
            this.currentLevelSaved = levelTestit - 1;
            this.currentLevelPlaying = levelTestit - 1;
            if (levelTestit > this.allLevelAnimationGrouped.length) { console.log(`Check the LevelAnimation for debbug , only have ${this.allLevelAnimationGrouped.length} Levels , try a less number`); return; }
            else console.log(`CurrentLevel-Playing:${levelTestit} - Max-Level:${this.allLevelAnimationGrouped.length}`);
        }
        else { this.percetageIncrementLevels++ }
        this.elementTextPIXIAPP.visible = true;
        void this.IncrementLevels();
    }

    public PathDebuggerTest(command: string) {
        if (command == "pathsra") {
            let randomPath = this.animationArrayCollect.filter(anim => anim.includes("animationCollectPath_")).random();
            let animationTrack = this.allAnimationMap.get(randomPath);
            this.PlayAnimationSpine(animationTrack.animationName, animationTrack.trackAnimationIndex, animationTrack.soundTrack);
        } else {
            if (this.intervalSRAPathDebugger.Running() != true) this.intervalSRAPathDebugger.Start();
        }
    }

    protected startWinShow: boolean = false;
    public OnStartBigWinShow() {
        //this.changeRandomAnimationSpineInterval?.Stop();
        this.startWinShow = true;
        //if (this.allAnimationMap.has("EXPECTATION") == true) this.allAnimationMap.get("EXPECTATION").isActive = true;
        if (this.allAnimationMap.has("EXPECTATION") == true && this.spineHit != null && this.startWinShow == true) {
            let animationTrack = this.allAnimationMap.get("EXPECTATION");
            //this.allAnimationMap.get("EXPECTATION").isActive = true;
            this.PlayAnimationSpine(animationTrack.animationName, animationTrack.trackAnimationIndex, animationTrack.soundTrack);
            if (this.allAnimationMap.has(this.animatioBreathName) == true) {
                this.AddQueueAnimation(this.animatioBreathName, this.trackIndexIDLE, false, 0 , this.spineHit);
            };
        };
    }

    public OnEndBigWinShow() {
        if (this.startWinShow == true) {
            //this.changeRandomAnimationSpineInterval?.Restart();
            this.startWinShow = false;
        }
    }

    public Update(): void {
    }

    public override Destroy() {
        this.elementTextPIXIAPP.removeFromParent();
        this.elementTextPIXIAPP.destroy(true);
        this.elementTextPIXIAPP = null;
        this.currentLevelSaved = 0;
        this.currentSpin = 0;
        this.currentLevelPlaying = 0;
        //this.SaveCurrentIncrement();        
        //this.spineHit.state.clearTracks();
        //this.spineHit.state.clearListeners();        
        //this.animationArrayRASuffle = [];
        this.animationArrayBackground = [];
        this.animationArrayCollect = [];
        //this.animationArrayRA = [];
        this.allLevelAnimationGrouped = [];
        //this.lastindexAnimInterval = null;
        //this.currentRandomAnimationIndex = null;
        //this.spineHit = null;
        //this.intervalLevelRAAnimation?.Stop()
        //this.changeRandomAnimationSpineInterval?.Stop();
        this.backgroundLiveSpineTimeout?.Stop();
        //this.changeRandomAnimationSpineInterval?.Stop();
        //this.intervalLevelRAAnimation?.Stop();
        this.startRALevelLoopTimeout?.Stop();
        this.intervalSRAPathDebugger?.Stop();
        //console.log("Family-Constructive-Destroyed-",this.resid.ID());
        this.someLevelAnimISPlaying = false;
        this.bonusWinHasHitted = false;
        //this.ClearLevels();
        //this.ResetPoseSpine();
        this.startBonusWin = false;
        //this.animationExpectation = null;
        //this.tracksEnabled.clear();
        //this.spineHit.destroy();
        // if (  this.spineHit.parent) {
        //       this.spineHit.parent.removeChild(  this.spineHit);
        // }
        // this.spineHit = null;
    }

    public override AddTrack(track: ITrack, nameTrack: string) {
        this.spineTrackMap.set(nameTrack, track);
    }

    public override FillingPotDebuggerRAAnimationDebugger(numberAnimToPlay: RegExpMatchArray) {
        // this.elementTextPIXIAPP.visible = true;
        // this.changeRandomAnimationSpineInterval.Stop();
        // let indexRA = parseInt(numberAnimToPlay[0]) - 1
        // if (indexRA < this.animationArrayRA.length) {
        //     console.log("FamilyConstructive-AnimationRATOPlay:", this.animationArrayRA[indexRA]);
        //     let animationTrack = this.allAnimationMap.get(this.animationArrayRA[indexRA]);
        //     this.PlayAnimationSpine(animationTrack.animationName, animationTrack.trackAnimationIndex, animationTrack.soundTrack)
        //     let audio = this.spineTrackMap.get(this.animationArrayRASuffle[indexRA]);
        //     if (audio != null) audio.Play(false);
        //     console.log("FamilyConstructive-AnimationRATOPlay-Sound:", this.spineTrackMap.get(this.animationArrayRASuffle[this.currentRandomAnimationIndex]));
        //     this.ShowDebuggerAnim(animationTrack);

        //     setTimeout(() => {
        //         this.changeRandomAnimationSpineInterval.Start();
        //     }, (animationTrack.duration * 1000) + 5500);
        // } else {
        //     console.log("RA_Anim Dose't exist , change index :  1 to 10 , availablesRA :", this.animationArrayRA.length);
        // }
    }

    public GetCurrentLevels(): IIncrementSavePerBet {
        return {
            familyParticles: null,
            familyConstructive: this.availableLevelPerBet,
            familyConstrutiveMultPot : null
        }
    }

    public SetCurrentFromBaseGameLevels(incrementSavePerBet: IIncrementSavePerBet) {
        if (incrementSavePerBet != null) this.availableLevelPerBet = incrementSavePerBet.familyConstructive;
    }

    protected PlayAnimationSpine(nameAnimation: string, trackAnimationIndex: number, soundTrack: ITrack, speedAnimation: number = null, loopAnim: boolean = false, trackComplete?: ITrackEntry) {
        if (loopAnim == true && !trackComplete == true) {
            trackComplete.trackTime = 0;
            soundTrack?.Play();
            return
        }
        else {
            this.spineHit?.state?.addEmptyAnimation(trackAnimationIndex, 0, 0);
            this.spineHit?.state?.setEmptyAnimation(trackAnimationIndex, 0);
            let trackAnimation = this.spineHit?.state?.setAnimation(trackAnimationIndex, nameAnimation, false);
            if (trackAnimation && speedAnimation != null) {
                trackAnimation.timeScale = speedAnimation;
            }
            //this.allAnimationMap.get(nameAnimation).trackAnimationIndex = trackAnimationIndex;
            soundTrack?.Play();
        }
    }

    // protected AddQueueAnimation(nameAnimation: string, trackAnimationIndex: number, loopAnim = false, delay: number = 0) {
    //     this.spineHit?.state.addAnimation(trackAnimationIndex, nameAnimation, loopAnim, delay);
    // }


    protected ClearLastLevel() {
        let LevelAnimationArray = this.allLevelAnimationGrouped.filter(animsLevel => animsLevel.level == this.currentLevelPlaying - 1);

        for (let animationIndex = 0; animationIndex < LevelAnimationArray?.[0]?.levelStartAnims?.length; animationIndex++) {
            this.allAnimationMap.get(LevelAnimationArray?.[0]?.levelStartAnims[animationIndex]).isActive = false;
            this.allAnimationMap.get(LevelAnimationArray?.[0]?.levelStartAnims[animationIndex]).loopAnimation = false;
            this.spineHit?.state?.addEmptyAnimation(this.allAnimationMap.get(LevelAnimationArray?.[0]?.levelStartAnims[animationIndex]).trackAnimationIndex, 0, 0);
            this.spineHit?.state?.setEmptyAnimation(this.allAnimationMap.get(LevelAnimationArray?.[0]?.levelStartAnims[animationIndex]).trackAnimationIndex, 0);
        }
        for (let animationIndex = 0; animationIndex < LevelAnimationArray?.[0]?.levelLoopAnims?.length; animationIndex++) {
            this.allAnimationMap.get(LevelAnimationArray?.[0]?.levelLoopAnims[animationIndex]).isActive = false;
            this.allAnimationMap.get(LevelAnimationArray?.[0]?.levelLoopAnims[animationIndex]).loopAnimation = false;
            this.spineHit?.state?.addEmptyAnimation(this.allAnimationMap.get(LevelAnimationArray?.[0]?.levelLoopAnims[animationIndex]).trackAnimationIndex, 0, 0);
            this.spineHit?.state?.setEmptyAnimation(this.allAnimationMap.get(LevelAnimationArray?.[0]?.levelLoopAnims[animationIndex]).trackAnimationIndex, 0);
        }
        LevelAnimationArray = null;

    }
}
